function MigrateInventoryModalCtrl($scope, inventory, $uibModalInstance, $timeout, deferred, activeInventoryService) {
  $scope.inventory = inventory;

  $scope.inventoryForm = {
    recurringEndDate: null
  };

  $scope.save = function(form, $event) {
    if (!form) throw new Error('form is required');
    if ($event) $event.preventDefault();

    $scope.submitted = true;

    if (!form.$valid) return Promise.reject(new Error('form is invalid'));

    $scope.saving = true;

    return activeInventoryService.performActionById($scope.inventory.id, {
        type: 'MIGRATE_TO_RECURRING',
        recurringEndDate: $scope.inventoryForm.recurringEndDate
      })
      .then(result => {
        $timeout(() => {
          deferred.resolve({
            inventory: result
          });
        }, 100);
      });
  };

  $scope.close = function() {
    deferred.resolve(false);
  };
}

MigrateInventoryModalCtrl.$inject = [
  '$scope',
  'inventory',
  '$uibModalInstance',
  '$timeout',
  'deferred',
  'jsSdk.inventory'
];

export default MigrateInventoryModalCtrl;



// WEBPACK FOOTER //
// ./src/modals/migrateInventory/controller.js